enum NavBarMode {
    None = "none",
    Light = "light",
    Dark = "dark",
    Brat = "brat"
}

export {NavBarMode}